export const NAME = 'NAME'
export const SUBJECT = 'SUBJECT'
export const EMAIL = 'EMAIL'
export const CONTENT = 'CONTENT'